<template>
    <div class="task-body-main-block">
        <div :class="[task.body_html == null && task.body == null ? 'loading' : '', 'task-body-container']">
            <div class="edit-text-body" v-if="edit_modal_toggle">
                <TextArea
                    v-model="task.body"
                    :rows="4"
                    :placeholder="'Write a markdown description. Press / for commands'"
                    :readonly="!edit_modal_toggle"
                    :copyBtn="false"
                    :overflow="true"
                    ref="textareaBody"
                    @focus="setEditableBody"
                    @input="handleInput"
                    class="task-body"
                    @keydown="keyDownHandler"
                    @keyup="keyUpHandler"
                />
            </div>
            <div v-else-if="lockingTask" class="locking-task">Locking Task <LoaderAnimationVue /></div>
            <div v-else-if="task.body_html?.trim() === ''" class="task-body-html" @dblclick="editBodyTask($event)" @click="editLocklessElementBody($event)">Double click to edit task markdown description</div>
            <div v-else ref="bodyHtml" class="task-body-html" @dblclick="editBodyTask($event)" @click="editLocklessElementBody($event)" v-html="task.body_html"></div>

            <CopyBtn @mouseDownHandler="funcKeyPressed = true" :value="task.body" />
            <div ref="mute-calc-block" class="mute-calc-block">
                <span v-html="f_commentText"></span><span class="position"></span>
            </div>
        </div>
            
        <div :class="[showCommandsSuggestions ? 'show' : '', 'commands-suggestion-block']">
            <ul class="commands-list" ref="commandsList">
                <li
                    v-for="(cmd, i) in commands"
                    :key="i"
                >
                    <a
                        href="#"
                        @mousedown="funcKeyPressed = true"
                        @click.prevent="addUserSelect(cmd)"
                        :data-id="i"
                    >
                        {{ cmd.label }}
                    </a>
                </li>
            </ul>
        </div>
        <span 
            v-if="edit_modal_toggle"
            class="hint"
        >
            Press Control + Enter to Comment
        </span>
        <VButton
            v-if="edit_modal_toggle"
            class="save-task-edit-btn"
            active
            @mouseDown="taskEdit"
        >
            Save
        </VButton>
        <VButton
            v-if="edit_modal_toggle"
            class="cancel-task-edit-btn"
            @mouseDown="$emit('setCancelEditing'), taskEdit()"
        >
            Cancel
        </VButton>
        <Flash ref="show"/>
    </div>
</template>
<script>
import Vue from 'vue';
import {api} from "@/mixins/axios";
import Flash from "@/components/Flash.vue";
import VButton from "@/components/atoms/VButton";
import TextArea from "@/components/atoms/TextArea.vue";
import CopyBtn from "@/components/atoms/CopyBtn.vue";
import party from "party-js";
import LoaderAnimationVue from "@/components/atoms/LoaderAnimation.vue";
import textareaCaret from 'textarea-caret';

export default {
    name: "TaskBody",
    components: {
        VButton,
        Flash,
        TextArea,
        CopyBtn,
        LoaderAnimationVue
    },
    props: ["task", "edit_modal_toggle", "lockingTask"],
    data: function () {
        return {
            funcKeyPressed: false,
            bodyContentOnCancel: '',
            showCommandsSuggestions: false,
            commands: [
                {label: 'Checklist', code: '- [ ] Checklist item', newLine: true, selectionStart: 4, selectionEnd: 18},
                {label: 'Boldface', code: '**Your text**', selectionStart: 2, selectionEnd: 11},
                {label: 'Italic', code: '*Your text*', selectionStart: 1, selectionEnd: 10},
                {label: 'Header 1', code: '# H1', newLine: true, selectionStart: 0, selectionEnd: 2},
                {label: 'Header 2', code: '## H2', newLine: true, selectionStart: 1, selectionEnd: 3},
                {label: 'Header 3', code: '### H3', newLine: true, selectionStart: 2, selectionEnd: 4},
                {label: 'Horizontal Line', code: '---', newLine: true, selectionStart: 5, selectionEnd: 5},
            ],
            original_body: ''
        };
    },
    computed: {
        taskArray() {
            return this.task.body.split('\n')
        },
        f_commentText() {
            if(!this.task.body || this.task.body.length == 0) return ''
            return this.task.body.replace(/(?:\r\n|\r|\n)/g, '<br>')
        },
        isTaskEditing() {
			return this.$store.getters.isTaskEditing
		},
        editableTask() {
            return this.$store.getters.editableTask
        },
        boardLists() {
            return this.$store.getters.activeBoardTasks
        },
    },
    watch: {
        'task.body_html': function() {
            setTimeout(() => this.checkAndAppendCopyBtn(), 250)
        }
    },
    async mounted() {
		document.querySelector('body').addEventListener('click', (e) => {
			if(!this.findParentTag(e.target, this.$el)) {
				this.showCommandsSuggestions = false;
			}
		});

        this.checkAndAppendCopyBtn();
    },
    created() {
        window.addEventListener('keydown', this.handleKeydown);
    },
    methods: {
        checkAndAppendCopyBtn() {
            const container = this.$refs.bodyHtml;
            if (!container) return
            const preElements = container.querySelectorAll('pre');

            if (preElements.length > 0) {
                preElements.forEach(preElement => {
                    const copyBtnProps = {
                        value: preElement.innerText
                    };
                    const copyBtnComponent = new Vue({
                        render: h => h(CopyBtn, { props: copyBtnProps }),
                    });
    
                    copyBtnComponent.$mount();
    
                    preElement.appendChild(copyBtnComponent.$el);
                })
            }
        },
        handleKeydown(event) {
            if (event.key !== 'Escape') return;

            if (this.showCommandsSuggestions) {
                this.hideCommandSuggestion()
            } else if (this.isTaskEditing && !this.showCommandsSuggestions) {
                this.$emit('hiddenCancel')
            }
        },
        setTextareaHeight(refItem) {
            const childTextareEl = this.$refs[refItem].$el.querySelector('textarea');
            childTextareEl.style.height = 'auto';
            childTextareEl.style.height = childTextareEl.scrollHeight + 5 + 'px';
        },
        handleInput(val, e) {
            this.funcKeyPressed = false
            this.setTextareaHeight('textareaBody')

            if (e.inputType == "historyUndo" || e.inputType == "historyRedo" || e.inputType == 'deleteByCut') {
                this.funcKeyPressed = true
                this.jumpToCaret(e.target);
            }
        },
        jumpToCaret(textarea) {
            setTimeout(() => {
                textarea.blur();
                textarea.focus();
                this.funcKeyPressed = false
            }, 0);
        },
        editBodyTask(event) {
            if (this.draggingBodyContent) return

            if (event.target.tagName === 'INPUT' && event.target.getAttribute('type') === 'checkbox') {
                return
            } else if (event.target.type == 'checkbox') {
                return
            } else if (event.target.tagName === 'A') {
                return
            } else {
                this.original_body = this.task.body
                this.$emit('lockTask', event)
            }

            this.$store.dispatch('setTaskEditing', true)
        },
        async editLocklessElementBody(event) {
            const checkboxes = document.querySelector('.task-body-html')?.querySelectorAll('ul li input[type="checkbox"]')
            checkboxes?.forEach((checkbox, index) => checkbox.setAttribute('data-index', index))
            
            let currentIndex

            if (event.target.tagName === 'INPUT' && event.target.getAttribute('type') === 'checkbox') {
                currentIndex = Number(event.target.getAttribute('data-index'))
                this.editChecklistItem(event.target, currentIndex)
            }
        },
        async editChecklistItem(element, index) {
            if (element.checked) {
                let random = Math.random()
                if (random >= 0.66) {
                    party.confetti(element);
                }
            }

            try {
                const data = {
                    task_id: this.task.id,
                    position: index,
                    value: element.checked
                };

                const response = await api.post("/task_edit_checklist", data);
                if (response.data.msg == 'ok') {
                    const task = this.task
                    task.body = response.data.data.body
                    task.body_html = response.data.data.body_html
                    this.$store.dispatch('setEditableTask', task)
                    // this.$store.dispatch('editTaskDescription', {
                    //     body: response.data.data.body,
                    //     body_html: response.data.data.body_html,
                    //     list_id: response.data.data.list_id,
                    //     id: response.data.data.id
                    // })
                    // console.log(this.boardLists[0].tasks[0].body_html);
                    // console.log(this.editableTask.body_html);
                }
            } catch(e) {
                console.log(e);
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || `Something went wrong`)
                element.checked = !element.checked
            }
        },
        taskEdit() {
            this.$emit('taskEdit', this.funcKeyPressed, this.bodyContentOnCancel);

            if (this.funcKeyPressed) {
                this.jumpToCaret(this.$refs['textareaBody'].$el.querySelector('textarea'));
            }
        },
        keyDownHandler(e) {
            let holder = this.$el.querySelectorAll('.commands-list a')

            if(e.ctrlKey && e.key == 'Enter') {
                this.taskEdit()
            }
            if(e.key === '/') {
                this.showCommandsSuggestions = true
                this.calcDropPosition()
                holder[0].classList.add('hover')
            } else if(e.key === 'Enter') {
                if(this.showCommandsSuggestions) e.preventDefault()
                let activeID = null;
                holder.forEach(i => {
                    if(i.classList.contains('hover')) {
                        activeID = i.getAttribute('data-id')
                        return
                    }
                })
                holder.forEach(i => i.classList.remove('hover'))
                this.addUserSelect(this.commands[activeID])
            } else if(e.code === 'Space') {
                this.hideCommandSuggestion()
            } else if(e.key === 'ArrowDown' && this.showCommandsSuggestions) {
                e.preventDefault()
                this.navigateDropDown()
            } else if(e.key === 'ArrowUp' && this.showCommandsSuggestions) {
                e.preventDefault()
                this.navigateDropUp(e)
            } else if (e.key === 'Escape') {
                e.preventDefault();
            } else {
                this.hideCommandSuggestion();
            }
        },
        keyUpHandler(e) {
            let holder = this.$el.querySelectorAll('.commands-list a')

            if(e.key === 'Backspace' && e.target.value.slice(-1) == '/') {
                // this.showCommandsSuggestions = true
                // holder[0].classList.add('hover')
            } else if(e.key === 'Backspace' && e.target.value.slice(-1) != '/') {
                this.hideCommandSuggestion()
            }

            if(this.task.body.length == 0) {
                this.hideCommandSuggestion()
            }
        },
        calcDropPosition() {
            const textarea = this.$refs['textareaBody'].$el.querySelector('textarea')
            const caret = textareaCaret(textarea, textarea.selectionEnd);

            this.$el.querySelector('.commands-suggestion-block').style.top = caret.top + 30 + 'px';
            this.$el.querySelector('.commands-suggestion-block').style.left = caret.left + 'px';
        },
        hideCommandSuggestion() {
            this.$el.querySelectorAll('.commands-list a').forEach(i => i.classList.remove('hover'))
            this.$el.querySelector('.commands-suggestion-block').scrollTop = 0;
            this.showCommandsSuggestions = false
        },
        addUserSelect(cmd) {
            if(this.showCommandsSuggestions) {
                const start = this.$refs['textareaBody'].$el.querySelector('textarea').selectionStart
                const end = this.$refs['textareaBody'].$el.querySelector('textarea').selectionEnd

                const textBefore = this.task.body.substring(0, start - 1);
                const textAfter = this.task.body.substring(end);

                let selectionStart = cmd.selectionStart
                let selectionEnd = cmd.selectionEnd

                let updatedText
                if (cmd.newLine) {
                    const updatedTxt = this.newLineCommand(textBefore, textAfter, cmd, selectionStart, selectionEnd)
                    updatedText = updatedTxt.text;
                    selectionStart = updatedTxt.selectionStart
                    selectionEnd = updatedTxt.selectionEnd
                } else {
                    updatedText = textBefore + cmd.code + textAfter;
                }

                this.task.body = updatedText
                this.showCommandsSuggestions = false
                setTimeout(() => {
                    this.$refs['textareaBody'].$el.querySelector('textarea').focus()

                    if (cmd.newLine) {
                        this.$refs['textareaBody'].$el.querySelector('textarea').selectionStart = start + selectionStart + 1
                        this.$refs['textareaBody'].$el.querySelector('textarea').selectionEnd = start + selectionEnd + 1
                    } else {
                        this.$refs['textareaBody'].$el.querySelector('textarea').selectionStart = start + selectionStart - 1
                        this.$refs['textareaBody'].$el.querySelector('textarea').selectionEnd = start + selectionEnd - 1
                    }

                    this.setTextareaHeight('textareaBody')
                }, 100);
            }
        },
        newLineCommand(textBefore, textAfter, cmd, selectionStart, selectionEnd) {
            if (textBefore.trim() !== "" && textAfter.trim() !== "") {
                var lines = textBefore.split('\n');
                var lineAbove = lines[lines.length - 1].trim();
                var lineBelow = textAfter.split('\n')[0].trim();

                if (lineAbove !== "" && lineBelow !== "") {
                    selectionStart++
                    selectionEnd++
                    return {
                        text: textBefore + "\n" + cmd.code + "\n" + textAfter,
                        selectionStart: selectionStart,
                        selectionEnd: selectionEnd
                    };
                } else {
                    selectionStart++
                    selectionEnd++
                    return {
                        text: textBefore + "\n" + cmd.code + textAfter,
                        selectionStart: selectionStart,
                        selectionEnd: selectionEnd
                    };
                }
            } else if (textBefore.trim() !== "") {
                selectionStart++
                selectionEnd++
                return {
                    text: textBefore + "\n" + cmd.code,
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd
                };
            } else {
                return {
                    text: cmd.code + "\n" + textAfter,
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd
                };
            }
        },
        navigateDropDown() {
            //don't remove, fix for dropdown arrow navigation
            var state = false;

            this.$el.querySelectorAll('.commands-list a').forEach((item, i, list) => {
                // check if result-list item has HOVER class and it's not the last item - to switch hover class to a next item
                if(!state && item.classList.contains('hover') && (i+1 != list.length)) {
                    this.highlightOption(i+1, i);
                    state = true;

                    //scroll to hovered item
                    this.$el.querySelector('.commands-suggestion-block').scrollTop = this.$el.querySelector('.commands-list a.hover').offsetTop;
                    
                //if result-list item is the last in the list - go to first item
                } else if(!state && item.classList.contains('hover') && (i+1 == list.length)) {
                    this.highlightOption(0, i);
                    state = true;
                }
            })
        },
        highlightOption(n, i) {
            this.$el.querySelectorAll('.commands-list a')[n].classList.add('hover');
            this.$el.querySelectorAll('.commands-list a')[i].classList.remove('hover');
        },
        navigateDropUp(e) {
            var state = false;

            this.$el.querySelectorAll('.commands-list a').forEach((item, i) => {
                // check if result-list item has HOVER class and it's not the first item - to switch hover class to a next item
                if(!state && item.classList.contains('hover') && i != 0) {
                    this.highlightOption(i-1, i);
                    state = true;

                    //scroll to hovered item
                    this.$el.querySelector('.commands-suggestion-block').scrollTop = this.$el.querySelector('.commands-list a.hover').offsetTop;

                //if result-list item is the first in the list - go to last item
                } else if(!state && item.classList.contains('hover') && i == 0) {
                    this.highlightOption(this.$el.querySelectorAll('.commands-list a').length-1, i);
                    state = true;
                }
            })
        },
		findParentTag(el, tag) {
			while(el.parentNode) {
				el = el.parentNode;
				if (tag == el) return el;
			}
			return null;
		},
        setEditableBody() {
            this.setTextareaHeight('textareaBody')
            this.bodyContentOnCancel = this.task.body
            this.$emit('textarea-blurred')
            this.$store.dispatch('setTaskEditing', true)
        }
    },
};
</script>

<style lang="scss">
.task-body-main-block {
    position: relative;

    .mute-calc-block {
        opacity: 0;
        position: absolute;
        z-index: -1;
        display: inline-block;
        color: transparent;
        top: 10px;
        left: 10px;
        line-height: 1.25;
        max-height: 732px;
        overflow: auto;

        .position {
            width: 1px;
        }
    }
}
.commands-suggestion-block {
    background-color: var(--primary-bg);
    border: 0.5px solid var(--outline);
    backdrop-filter: blur(6px);
    border-radius: 6px;
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 10;
    overflow-y: auto;
    overflow-x: hidden;
    opacity: 0;
    pointer-events: none;
    transform: translateY(15px);
    transition: .15s opacity, .15s transform;

    &.show {
        opacity: 1;
        pointer-events: auto;
        transform: translateY(0);
    }

    .commands-list {
        padding: 6px 4px;
        margin: 0;
        list-style-type: none;

        a {
            display: flex;
            align-items: center;
            padding: 3px 5px;
            border-radius: 3px;
            transition: .3s background-color;
            line-height: 1.125;
            font-size: 16px;
            margin: 2px 0;

            &.hover {
                background-color: var(--accent);
                color: #fff;
            }
            &:hover {
                background-color: var(--hover);
                color: var(--primary-text);
            }
            
        }
    }
}
</style>
